import { TransactionBank, BankConfiguration } from '../components/Bancos'

const routesBancos = [
    {
        path: '/bancos/catalogo',
        name: 'Catálogo de Bancos',
        icon: 'nc-icon nc-bank',
        component: <BankConfiguration />,
        permissions: ['156_CATALOGO_DE_BANCOS'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
    },
    {
        path: '/bancos/transacciones',
        name: 'Transacciones',
        icon: 'nc-icon nc-bank',
        component: <TransactionBank />,
        permissions: ['241_MODULO_BANCOS'],
        layout: '/app',
        visibility: true,
        subRoutes: [],
    },
]

export { routesBancos }
